import { EducationalTipsPage } from "./educationalTips";

export const EducationalTips = EducationalTipsPage;
